module.exports = __webpack_public_path__ + "assets/3cdc47c304dd1f8693b134f97fb02b97.mp3";